/* Safe localStorage helpers - fail quiet (private browsing, quota errors, etc). */

export const getFromStorage = (key, defaultValue) => {
  try {
    const item = window.localStorage.getItem(key);
    return item === null ? defaultValue : JSON.parse(item);
  } catch (error) {
    return defaultValue;
  }
};

export const setInStorage = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    return false;
  }
};

export const removeFromStorage = (key) => {
  try {
    window.localStorage.removeItem(key);
    return true;
  } catch (error) {
    return false;
  }
};
